import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSubjectForm from "../../forms/CreateOrUpdateSubjectForm";

interface CreateSubjectModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateSubjectModal: React.FC<CreateSubjectModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create New Subject"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateSubjectForm loading={loading} error={error} />
  </AppModal>
);

export default CreateSubjectModal;
